import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { intervalMs: Number };

  connect() {
    if (!this.hasIntervalMsValue || this.intervalMsValue <= 0) return;
    this.timeoutId = setTimeout(() => {
      window.location.reload();
    }, this.intervalMsValue);
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}
